<div class="modal-backdrop" *ngIf="showModal" (click)="close()"></div>

<div class="modal-container" *ngIf="showModal">
  <div class="modal-content" (click)="$event.stopPropagation()">
    <!-- Header -->
    <div class="modal-header">
      <div class="modal-title">
        <i class="fas fa-share"></i>
        <h2>Direcionar Ordem de Serviço</h2>
      </div>
      <button class="btn-close" (click)="close()" type="button">
        <i class="fas fa-times"></i>
      </button>
    </div>

    <!-- Body -->
    <div class="modal-body">
      <!-- Ordem de Serviço Atual -->
      <div class="current-setor-info">
        <i class="fas fa-map-marker-alt"></i>
        <div>
          <small>Ordem de Serviço Atual</small>
          <strong>{{ ordemServicoAtual }}</strong>
        </div>
      </div>

      <div class="alert alert-info mt-3">
        <i class="fas fa-info-circle"></i>
        Esta ação <strong>não cria uma nova OS</strong>. Você está direcionando a <strong>mesma Ordem de Serviço</strong> para outro destino (tipo de OS) e/ou status.
        <ng-container *ngIf="transacaoSelecionada; else semSelecaoDestino">
          <span *ngIf="configOrderMudara">A configuração (fluxo) de serviço associada ao novo status <strong>será alterada</strong>.</span>
          <span *ngIf="!configOrderMudara">A configuração (fluxo) de serviço <strong>permanece a mesma</strong>.</span>
        </ng-container>
        <ng-template #semSelecaoDestino>
          <span class="text-muted">Selecione um destino para ver se a configuração do serviço muda.</span>
        </ng-template>
      </div>

      <!-- Loading -->
      <div class="loading-state" *ngIf="loading">
        <div class="spinner-border spinner-border-sm text-primary" role="status"></div>
        <span>Carregando regras de direcionamento...</span>
      </div>

      <!-- Sem regras -->
      <div class="alert alert-warning mt-3" *ngIf="!loading && transacoesDisponiveis.length === 0">
        <i class="fas fa-exclamation-triangle"></i>
        Nenhuma regra de direcionamento disponível para o status atual.
      </div>

      <!-- Formulário -->
      <form class="direcionamento-form" *ngIf="!loading && transacoesDisponiveis.length > 0">

        <!-- Seleção da transação -->
        <div class="form-group">
          <label for="transacaoDestino">
            Destino da Ordem de Serviço / Novo Status <span class="required">*</span>
          </label>
          <select
            id="transacaoDestino"
            class="form-control"
            [(ngModel)]="transacaoSelecionadaId"
            [ngModelOptions]="{standalone: true}"
            (change)="transacaoTouched = true"
            [class.is-invalid]="transacaoTouched && !transacaoSelecionadaId">
            <option value="">Selecione o destino</option>
            <option *ngFor="let t of transacoesDisponiveis" [value]="t.transactionId">
              {{ t.destinoTypeOS || 'OS (não definida)' }} — Status: {{ t.novoStatusNome }}
            </option>
          </select>
          <div class="invalid-feedback" *ngIf="transacaoTouched && !transacaoSelecionadaId">
            Selecione o destino
          </div>
          <small class="form-text text-muted">
            <i class="fas fa-link"></i>
            A OS continuará com o mesmo número; somente o tipo/status (e possivelmente a configuração do serviço) serão atualizados.
          </small>
        </div>

        <!-- Preview da seleção -->
        <div class="direcionamento-preview" *ngIf="transacaoSelecionada">
          <div class="preview-header">
            <i class="fas fa-eye"></i>
            <span>Resumo do Direcionamento</span>
          </div>
          <div class="preview-content">
            <div class="preview-item status-highlight">
              <i class="fas fa-tag"></i>
              <span>
                Novo Status: <strong class="status-value">{{ transacaoSelecionada.novoStatusNome }}</strong>
              </span>
            </div>

            <div class="preview-item">
              <i class="fas fa-arrow-right"></i>
              <span>Tipo da OS: <strong>{{ ordemServicoAtual }}</strong> → <strong>{{ textoDestinoTypeOS }}</strong></span>
            </div>
          </div>
        </div>

        <!-- Observação -->
        <div class="form-group">
          <label for="observacao">
            Observação <span class="optional">(Opcional)</span>
          </label>
          <textarea
            id="observacao"
            class="form-control"
            [(ngModel)]="observacao"
            [ngModelOptions]="{standalone: true}"
            rows="3"
            placeholder="Digite informações adicionais sobre o direcionamento..."></textarea>
          <small class="form-text">
            <i class="fas fa-info-circle"></i>
            Adicione detalhes relevantes sobre o direcionamento, se necessário
          </small>
        </div>
      </form>
    </div>

    <!-- Footer -->
    <div class="modal-footer">
      <button class="btn btn-secondary" (click)="close()" type="button">
        <i class="fas fa-times"></i>
        Cancelar
      </button>
      <button
        class="btn btn-primary"
        (click)="confirmarDirecionamento()"
        type="button"
        [disabled]="!isFormValid() || loading">
        <i class="fas fa-check"></i>
        Confirmar Direcionamento
      </button>
    </div>
  </div>
</div>

